import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { useCart, useLang } from "../../lib/ctx";
import { img, rm } from "../../lib/api";

export const CartDrawer = () => {
  const { t } = useLang();
  const { items, games, open, setOpen, update, remove, removeGame, subtotal } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="shopee flex w-full flex-col border-[#eee] bg-white text-[#222] sm:max-w-md" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="font-display text-3xl tracking-widest text-white">{t("cart")}</SheetTitle></SheetHeader>
        <div className="flex-1 space-y-4 overflow-y-auto py-4">
          {!items.length && !games.length && <p className="text-zinc-400" data-testid="cart-empty">{t("emptyCart")}</p>}
          {items.map((i) => (
            <div key={i.variant_id} className="flex gap-3 border-b border-white/10 pb-4" data-testid={`cart-item-${i.sku}`}>
              <img src={img(i.image)} alt={i.title} className="h-20 w-16 object-cover" />
              <div className="flex-1">
                <p className="text-sm font-semibold">{i.title}</p>
                <p className="font-mono text-[11px] text-zinc-500">{[i.size, i.color].filter(Boolean).join(" · ")} · {i.sku}</p>
                <div className="mt-2 flex items-center gap-2">
                  <button onClick={() => update(i.variant_id, i.qty - 1)} className="border border-white/20 p-1" data-testid={`cart-dec-${i.sku}`}><Minus className="h-3 w-3" /></button>
                  <span className="w-6 text-center text-sm" data-testid={`cart-qty-${i.sku}`}>{i.qty}</span>
                  <button onClick={() => update(i.variant_id, i.qty + 1)} className="border border-white/20 p-1" data-testid={`cart-inc-${i.sku}`}><Plus className="h-3 w-3" /></button>
                  <button onClick={() => remove(i.variant_id)} className="ml-auto text-zinc-500 hover:text-red-400" data-testid={`cart-remove-${i.sku}`}><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
              <p className="text-sm text-[#C8A45D]">{rm(i.price * i.qty)}</p>
            </div>
          ))}
          {games.map((g) => (
            <div key={g.key} className="flex justify-between border-b border-white/10 pb-4" data-testid="cart-game-item">
              <div>
                <p className="text-sm font-semibold">{g.title}</p>
                <p className="font-mono text-[11px] text-zinc-500">ID {g.player_id}{g.server_id ? ` (${g.server_id})` : ""}</p>
                <button onClick={() => removeGame(g.key)} className="mt-1 text-xs text-zinc-500 hover:text-red-400">{t("remove")}</button>
              </div>
              <p className="text-sm text-[#C8A45D]">{rm(g.price)}</p>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 pt-4">
          <div className="mb-4 flex justify-between"><span className="text-zinc-400">{t("subtotal")}</span><span className="font-semibold" data-testid="cart-subtotal">{rm(subtotal)}</span></div>
          <Link to="/checkout" onClick={() => setOpen(false)} className={`btn-gold w-full ${!items.length && !games.length ? "pointer-events-none opacity-40" : ""}`} data-testid="cart-checkout-btn">{t("checkout")}</Link>
        </div>
      </SheetContent>
    </Sheet>
  );
};
